import { useCallback, useState } from 'react';
import styled from '@emotion/styled';
import { getLastLoginStrategy } from '@/auth/session';
import { config } from '@/config';
import { EnterpriseLogin } from './Login.Enterprise';
import { PasswordLogin } from './Login.Password';

export const LoginScreen = () => {

  const [strategy, setStrategy] = useState<'standard' | 'enterprise'>(getLastLoginStrategy()?.strategy || 'standard');

  const toggleStrategy = useCallback(() => {
    setStrategy(strategy => strategy === 'standard' ? 'enterprise' : 'standard');
  }, []);

  const renderStrategyToggle = useCallback(() => {
    if (!config().USERNAME_PASSWORD_LOGIN_ENABLED) {
      return null;
    }

    return (
      <StrategyToggleText onClick={toggleStrategy}>
        {`(${strategy === 'standard' ? 'Enterprise' : 'Password'} login)`}
      </StrategyToggleText>
    );
  }, [strategy, toggleStrategy]);

  return (
    <Root>
      <Wrap>

        <Card>
          <Title>Log In {renderStrategyToggle()}</Title>

          {strategy === 'enterprise' && <EnterpriseLogin />}
          {strategy === 'standard' && <PasswordLogin />}
        </Card>

      </Wrap>
    </Root>
  );
};

const Root = styled.div({
  height: `calc(100vh - var(--navbar-height))`,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: 100,
});

const Wrap = styled.div({
});

const StrategyToggleText = styled.span(({ theme }) => ({
  fontSize: 12,
  cursor: 'pointer',
  color: theme.palette.hyperlink,
  marginLeft: 5,
}));

const Title = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 20,
  fontFamily: theme.fonts.semiBold,
  color: theme.palette.black.main,
  marginBottom: 20,
}));

const Card = styled.div({
  width: 450,
  padding: 20,
  borderRadius: 5,
  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  backgroundColor: 'white',
});